export const GLOBAL_SEARCH_NAMESPACE = 'global-search' as const;
